import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, vShow as _vShow, normalizeClass as _normalizeClass, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/classroom_sync.png'
import _imports_1 from '@/assets/classroom.png'


const _hoisted_1 = { class: "relative flex flex-col flex-grow" }
const _hoisted_2 = { class: "flex flex-col w-full -mt-4" }
const _hoisted_3 = { class: "flex flex-col w-full mb-4" }
const _hoisted_4 = { class: "flex items-center" }
const _hoisted_5 = { class: "flex items-center space-x-1.5 mb-3" }
const _hoisted_6 = { class: "text-sm" }
const _hoisted_7 = { class: "text-sm" }
const _hoisted_8 = { class: "text-sm" }
const _hoisted_9 = {
  key: 0,
  class: "flex flex-col flex-grow"
}
const _hoisted_10 = { class: "flex items-center mb-2 -mt-2" }
const _hoisted_11 = {
  style: {"width":"22px","height":"22px"},
  class: "opacity-70",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("title", null, "sort", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("path", { d: "M18 21L14 17H17V7H14L18 3L22 7H19V17H22M2 19V17H12V19M2 13V11H9V13M2 7V5H6V7H2Z" }, null, -1)
const _hoisted_14 = [
  _hoisted_12,
  _hoisted_13
]
const _hoisted_15 = { class: "-mx-5 -my-2.5 w-max" }
const _hoisted_16 = {
  key: 0,
  class: "material-icons mr-2 text-primary"
}
const _hoisted_17 = { class: "flex items-center align-top" }
const _hoisted_18 = { class: "flex space-x-1 ml-2" }
const _hoisted_19 = { class: "flex items-center ml-2" }
const _hoisted_20 = {
  class: "cursor-pointer text-muted",
  for: "more-filters-btn"
}
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", { class: "material-icons-outlined" }, " file_download ", -1)
const _hoisted_22 = { class: "flex-grow overflow-y-auto" }
const _hoisted_23 = { class: "flex flex-col flex-grow w-full" }
const _hoisted_24 = { class: "flex flex-col items-center w-full mb-12 space-y-4 md:flex-row md:space-y-0 -mt-2" }
const _hoisted_25 = { class: "flex items-center space-x-2 ml-auto" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("span", { class: "mr-2 material-icons" }, "person_add", -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  style: {"width":"28px"}
}, null, -1)
const _hoisted_28 = { class: "grid grid-cols-1 gap-3 md:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-4" }
const _hoisted_29 = {
  key: 0,
  class: "flex flex-col items-center w-full h-full mt-12 md:col-span-3 2xl:col-span-4"
}
const _hoisted_30 = /*#__PURE__*/_createElementVNode("p", {
  style: {"font-size":"6rem"},
  class: "material-icons-outlined opacity-10"
}, " person_off ", -1)
const _hoisted_31 = { class: "opacity-40" }
const _hoisted_32 = {
  key: 1,
  class: "flex flex-col items-center w-full h-full mt-12 md:col-span-3 2xl:col-span-4"
}
const _hoisted_33 = /*#__PURE__*/_createElementVNode("p", {
  style: {"font-size":"6rem"},
  class: "material-icons-outlined opacity-10"
}, " person_off ", -1)
const _hoisted_34 = { class: "opacity-40" }
const _hoisted_35 = { class: "text-darkText" }
const _hoisted_36 = { class: "" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  style: {"width":"20px"},
  class: "inline mr-1"
}, null, -1)
const _hoisted_38 = { class: "text-darkText" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Tabs = _resolveComponent("Tabs")!
  const _component_CheckboxGroup = _resolveComponent("CheckboxGroup")!
  const _component_Btn = _resolveComponent("Btn")!
  const _component_Spinner = _resolveComponent("Spinner")!
  const _component_TextInput = _resolveComponent("TextInput")!
  const _component_DropdownMenu = _resolveComponent("DropdownMenu")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_NumberInput = _resolveComponent("NumberInput")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_StudentCard = _resolveComponent("StudentCard")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_UserPicker = _resolveComponent("UserPicker")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_Tabs, {
          class: "mt-2 mb-4",
          options: _ctx.viewModesAsOptions,
          modelValue: _ctx.viewMode,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.viewMode) = $event))
        }, null, 8, ["options", "modelValue"]),
        _withDirectives(_createElementVNode("div", {
          class: _normalizeClass([
						_ctx.examSelectionExpanded
							? 'max-h-100 overflow-auto'
							: 'max-h-0 overflow-y-hidden',
						'duration-200 ease-in-out w-full transition-max-height',
					])
        }, [
          _createVNode(_component_CheckboxGroup, {
            class: "flex flex-wrap",
            options: _ctx.examsAsSelectableOptions,
            modelValue: _ctx.selectedExamsIds,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedExamsIds) = $event)),
            usesCustomSlot: true,
            itemClass: 'mt-4 mr-5'
          }, {
            custom: _withCtx(({ item }) => [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", {
                  style: _normalizeStyle({
										'background-color': _ctx.examsColors[item.value],
										'margin-right': '5px',
										'min-width': '10px',
										'min-height': '10px',
										width: '10px',
										height: '10px',
										'border-radius': '50%',
									})
                }, null, 4),
                _createTextVNode(" " + _toDisplayString(item.content), 1)
              ])
            ]),
            _: 1
          }, 8, ["options", "modelValue"]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_Btn, {
              class: "mt-3 -ml-1 text-sm",
              variant: 'primary-borderless',
              size: 'xs',
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.selectedExamsIds = _ctx.mainStore.exams.map(e => e.id)))
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t("misc.select_all")), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_Btn, {
              class: "mt-3 text-sm",
              variant: 'primary-borderless',
              size: 'xs',
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.selectedExamsIds = _ctx.closedExamIds))
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.$t("course_insights.select_closed_exams")), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_Btn, {
              class: "mt-3 text-sm",
              variant: 'primary-borderless',
              size: 'xs',
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.selectedExamsIds = []))
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.$t("misc.unselect_all")), 1)
              ]),
              _: 1
            })
          ])
        ], 2), [
          [_vShow, _ctx.viewMode === 'exams']
        ])
      ])
    ]),
    (_ctx.viewMode === 'exams')
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          (_ctx.localLoading)
            ? (_openBlock(), _createBlock(_component_Spinner, {
                key: 0,
                variant: 'light',
                size: 'xl',
                class: "absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2"
              }))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_TextInput, {
              class: "w-full md:w-1/3",
              searchBar: true,
              leftIcon: 'search',
              placeholder: _ctx.$t('course_insights.search_students'),
              modelValue: _ctx.examsViewSearchText,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.examsViewSearchText) = $event))
            }, null, 8, ["placeholder", "modelValue"]),
            _createVNode(_component_DropdownMenu, {
              expanded: _ctx.examsViewSortingOptionsExpanded,
              onToggleExpanded: _cache[6] || (_cache[6] = ($event: any) => (
						_ctx.examsViewSortingOptionsExpanded = !_ctx.examsViewSortingOptionsExpanded
					))
            }, {
              activator: _withCtx(() => [
                _createVNode(_component_Btn, {
                  variant: 'icon',
                  outline: true,
                  class: ""
                }, {
                  default: _withCtx(() => [
                    (_openBlock(), _createElementBlock("svg", _hoisted_11, _hoisted_14))
                  ]),
                  _: 1
                })
              ]),
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_15, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.examsViewSortingOptions, (option, index) => {
                    return (_openBlock(), _createElementBlock("div", { key: index }, [
                      _createVNode(_component_Btn, {
                        outline: true,
                        class: "px-8 pt-2 pb-2 w-full",
                        variant: 'transparent',
                        onClick: ($event: any) => (_ctx.setSortingOption(index))
                      }, {
                        default: _withCtx(() => [
                          (index === _ctx.examsViewSelectedSortingOption)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_16, "done"))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_17, _toDisplayString(option.label), 1)
                        ]),
                        _: 2
                      }, 1032, ["onClick"])
                    ]))
                  }), 128))
                ])
              ]),
              _: 1
            }, 8, ["expanded"]),
            _createElementVNode("div", _hoisted_18, [
              _createVNode(_component_Dropdown, {
                modelValue: _ctx.examsViewSelectedFilterOption,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.examsViewSelectedFilterOption) = $event)),
                options: _ctx.examViewFilteringOptions,
                class: "w-60"
              }, null, 8, ["modelValue", "options"]),
              (_ctx.examsViewSelectedFilterOption !== 'no_filter')
                ? (_openBlock(), _createBlock(_component_NumberInput, {
                    key: 0,
                    style: {"padding-top":"0.5rem !important","padding-bottom":"0.645rem !important"},
                    elementId: 'grade-filter-value-input',
                    modelValue: _ctx.examsViewAverageGradeFilterValue,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.examsViewAverageGradeFilterValue) = $event)),
                    class: "w-16"
                  }, null, 8, ["modelValue"]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_19, [
              _createVNode(_component_Btn, {
                variant: 'icon',
                outline: true,
                onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.examSelectionExpanded = !_ctx.examSelectionExpanded)),
                class: "",
                id: "more-filters-btn"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", {
                    class: _normalizeClass(["transition-transform duration-200 ease-out transform material-icons-outlined", { 'rotate-180': _ctx.examSelectionExpanded }])
                  }, _toDisplayString("expand_more"), 2)
                ]),
                _: 1
              }),
              _createElementVNode("label", _hoisted_20, _toDisplayString(_ctx.$t("course_insights.filter_exams")), 1)
            ]),
            _createVNode(_component_Btn, {
              class: "ml-auto",
              disabled: _ctx.downloadingReport,
              outline: true,
              variant: 'icon',
              onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.downloadReport())),
              tooltip: _ctx.$t('misc.download_as_csv')
            }, {
              default: _withCtx(() => [
                _hoisted_21
              ]),
              _: 1
            }, 8, ["disabled", "tooltip"])
          ]),
          _createElementVNode("div", _hoisted_22, [
            (_ctx.showTable)
              ? (_openBlock(), _createBlock(_component_DataTable, {
                  key: 0,
                  class: _normalizeClass({ 'opacity-60': _ctx.loading || _ctx.localLoading }),
                  columnDefs: _ctx.tableHeaders,
                  rowData: _ctx.loading ? [] : _ctx.tableData,
                  getRowId: _ctx.getRowId,
                  onGridReady: _cache[11] || (_cache[11] = ($event: any) => {
						_ctx.gridApi = $event.api;
						_ctx.columnApi = $event.columnApi;
						_ctx.columnApi.autoSizeAllColumns(false);
					})
                }, null, 8, ["class", "columnDefs", "rowData", "getRowId"]))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    _withDirectives(_createElementVNode("div", _hoisted_23, [
      _createElementVNode("div", _hoisted_24, [
        _createVNode(_component_TextInput, {
          class: "w-full md:w-1/2",
          searchBar: true,
          leftIcon: 'search',
          placeholder: _ctx.$t('course_insights.search_students'),
          modelValue: _ctx.usersViewSearchText,
          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.usersViewSearchText) = $event))
        }, null, 8, ["placeholder", "modelValue"]),
        _createElementVNode("div", _hoisted_25, [
          _createVNode(_component_Btn, {
            class: "",
            onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.onEnrollUsers()))
          }, {
            default: _withCtx(() => [
              _hoisted_26,
              _createTextVNode(" " + _toDisplayString(_ctx.$t("course_insights.enroll_students")), 1)
            ]),
            _: 1
          }),
          (_ctx.classroomIntegrationActive)
            ? (_openBlock(), _createBlock(_component_Btn, {
                key: 0,
                outline: true,
                variant: 'icon',
                class: "",
                style: {"margin-top":"2px"},
                onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.showClassroomSyncDialog = true)),
                tooltip: _ctx.$t('integrations.classroom.sync_classroom_roster')
              }, {
                default: _withCtx(() => [
                  _hoisted_27
                ]),
                _: 1
              }, 8, ["tooltip"]))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_28, [
        (!_ctx.loading && _ctx.mainStore.enrolledUsers.length === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
              _hoisted_30,
              _createElementVNode("h2", _hoisted_31, _toDisplayString(_ctx.$t("course_insights.no_enrolled_students")), 1)
            ]))
          : (!_ctx.loading && _ctx.filteredEnrolledUsers.length === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                _hoisted_33,
                _createElementVNode("h2", _hoisted_34, _toDisplayString(_ctx.$t("course_insights.no_users_matching_search")), 1)
              ]))
            : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredEnrolledUsers, (user) => {
          return (_openBlock(), _createBlock(_component_StudentCard, {
            class: "mb-auto",
            key: 'enrolled-user-' + user.id,
            user: user
          }, null, 8, ["user"]))
        }), 128))
      ])
    ], 512), [
      [_vShow, _ctx.viewMode === 'students']
    ]),
    _createVNode(_component_Dialog, {
      showDialog: _ctx.showClassroomSyncDialog,
      onYes: _cache[15] || (_cache[15] = ($event: any) => (_ctx.onSyncClassroomRoster())),
      onNo: _cache[16] || (_cache[16] = ($event: any) => (_ctx.showClassroomSyncDialog = false)),
      yesText: 
				_ctx.syncingClassroomRoster
					? _ctx.$t('misc.wait')
					: _ctx.$t('integrations.classroom.sync_roster')
			,
      noText: _ctx.$t('dialog.default_cancel_text'),
      disableOk: _ctx.syncingClassroomRoster,
      loading: _ctx.syncingClassroomRoster
    }, {
      title: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t("integrations.classroom.sync_classroom_roster")), 1)
      ]),
      body: _withCtx(() => [
        _createElementVNode("p", _hoisted_35, [
          _createTextVNode(_toDisplayString(_ctx.$t("integrations.classroom.sync_classroom_roster_description_1")) + " ", 1),
          _createElementVNode("span", _hoisted_36, [
            _hoisted_37,
            _createElementVNode("strong", null, _toDisplayString(_ctx.googleClassroomCourseTwin?.data?.name), 1)
          ]),
          _createTextVNode(" " + _toDisplayString(_ctx.$t("integrations.classroom.sync_classroom_roster_description_2")) + " ", 1),
          _createElementVNode("strong", null, _toDisplayString(_ctx.currentCourse.name), 1),
          _createTextVNode(". ")
        ])
      ]),
      _: 1
    }, 8, ["showDialog", "yesText", "noText", "disableOk", "loading"]),
    _createVNode(_component_Dialog, {
      showDialog: _ctx.showBlockingDialog,
      onYes: _cache[18] || (_cache[18] = ($event: any) => (_ctx.resolveBlockingDialog(true))),
      onNo: _cache[19] || (_cache[19] = ($event: any) => (_ctx.resolveBlockingDialog(false))),
      yesText: _ctx.enrollingUsers ? _ctx.$t('misc.wait') : _ctx.$t('course_insights.enroll'),
      noText: _ctx.$t('dialog.default_cancel_text'),
      disableOk: _ctx.usersToEnrollCount === 0 || _ctx.enrollingUsers,
      large: true,
      footerBorder: true,
      loading: _ctx.enrollingUsers
    }, {
      title: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t("course_insights.add_enrolled_students")), 1)
      ]),
      body: _withCtx(() => [
        _createElementVNode("div", _hoisted_38, [
          _createVNode(_component_UserPicker, {
            modelValue: _ctx.usersToEnroll,
            "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.usersToEnroll) = $event))
          }, null, 8, ["modelValue"])
        ])
      ]),
      _: 1
    }, 8, ["showDialog", "yesText", "noText", "disableOk", "loading"])
  ]))
}